<span class="feed-entry flex-column"
    (click)="selected.emit(data)">
    <div kui-action
        class="d-flex flex-1"
        [ngClass]="classNames">
        <key-feed-entry-info>
            <span id="info-title">
                <span [title]="data | getKey: 'date' | date: 'yyyy-MM-dd HH:mm:ss'">{{ data | getKey: 'date' | units: { unit: 'time', variant: 'short'} }}</span>
            </span>
            <span id="info-small-text"
                class="small muted">{{ getDisplayDate(data.date) }}</span>
        </key-feed-entry-info>

        <div class="feed-entry-details">
            <div class="d-flex flex-wrap">
                <div class='entry-text flex-1 mr-1 mb-2'>

                    <div class="entry-title accent d-flex">
                        <div class="filter-link flex-1"
                            [title]=" 'VIDEOS.LIST.CLICK_TO_FILTER' | translate"
                            (click)="showFilterByValue && filterBy($event, 'asset')">{{title}}</div>
                    </div>
                    <div class="entry-description muted-less">
                        {{description}}
                    </div>

                    @if (eventSpecificDescription) {
                        <div class="request-description mt-1 mb-1">
                            {{eventSpecificDescription}}
                        </div>
                    }

                    @if (showSaveVideoButton()) {
                        <span kui-tooltip="{{ saveVideoBtnDisabledTooltip() }}" [showOnTouchscreen]="true">
                            <button
                                kui-button
                                [disabled]="data.status !== 'ready'"
                                (click)="saveVideo.emit(data)"
                                class="mr-1 mt-1"
                                color="primary">
                                    {{ 'DIALOG.SAVE' | translate }}
                            </button>
                        </span>
                    }

                    @if (showDeleteVideoButton()) {
                        <span (click)="deleteVideo.emit(data)" class="mr-1 text-danger small inline">
                            <kui-icon name="trash-alt" [size]="'xs'" [color]="'danger'" class="mr-1"></kui-icon>
                                {{ 'DIALOG.DELETE' | translate }}
                        </span>

                        <span class="small inline muted">
                            {{ savedFrom }}
                        </span>
                    }
                </div>
            </div>

        </div>


    </div>

    <div class="media-thumbnail mb-2"
        *ngIf="thumbnailUrls">
        <key-video-thumbnail *ngFor="let url of thumbnailUrls"
            [url]="url">
        </key-video-thumbnail>
    </div>

</span>